<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page

========================================================================================== -->

<template>
  <div>
    <div
      class="rounded-lg w-full"
      style="
        background-image: url(https://ip-connect-zone.b-cdn.net/page-banners/app-launcher.png);
        background-size: cover;
        box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
      "
    >
      <div class="knowledge-base-jumbotron-content lg:p-12 sm:p-10 p-8 rounded-lg mb-8" style="height: 100%; border: 1px solid #222f44">
        <h5 class="font-light text-dark">Apps Launcher</h5>
        <h1 class="mb-1 text-white font-bold" id="app-launcher-header" style="font-size: 2.9rem">Select an App to Launch</h1>
      </div>
    </div>
    <div v-if="apps.length">
      <slide-x-left-transition group class="w-full h-full grid grid-cols-5 gap-x-4" id="app-cards-grid" tag="div">
        <div v-for="app in apps" :key="app.id" class="vx-col mb-base w-full">
          <app-card :app="app" />
        </div>
      </slide-x-left-transition>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>

<!--suppress ES6ShorthandObjectProperty -->
<script>
import AppCard from './components/AppCard';

export default {
  data() {
    return {
      apps: [],
    };
  },
  components: {
    AppCard,
  },
  methods: {
    fetchAppsList() {
      // if (this.activeCourseInfo.selected === false) {
      //   this.$vs.notify({
      //     title: 'No Course Selected',
      //     text: 'Please select a courses before practicing',
      //     color: 'danger',
      //     position: 'top-right'
      //   })
      //   return this.$router.push('/courses')
      // }
      this.apps = [];
      this.activeCourseInfo.appsEnabled.forEach((app, index) => {
        setTimeout(() => {
          this.apps.push(app);
        }, index * 60);
      });
    },
  },
  beforeMount() {
    this.fetchAppsList();
  },
  computed: {
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse;
    },
  },
};
</script>

<style lang="scss">
.card-width-app {
  width: 20%;
}

@media (max-width: 2200px) {
  .card-width-app {
    width: 25%;
  }
}

@media (max-width: 1800px) {
  .card-width-app {
    width: 33.333333%;
  }
}

@media (max-width: 1300px) {
  .card-width-app {
    width: 50%;
  }
  #app-cards-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}

@media (max-width: 750px) {
  .card-width-app {
    width: 100%;
  }
  #app-cards-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  #app-launcher-header {
    font-size: 2rem !important;
  }
}
</style>
